import { Auth } from '@/middlewares/Auth'

export class Http {
  public static async request (url: RequestInfo, options: RequestInit = {}, tryAuthRefresh = true): Promise<Response> {
    if (process.env.NODE_ENV !== 'development') {
      // capacitor URL fix
      if (!url.toString().startsWith('https://localhost')) {
        url = 'https://www.backroadclub.com' + url
      }
      options.credentials = 'include'
    }

    // add auth header
    if (!options.headers) {
      options.headers = {}
    }

    const accessToken = window.localStorage.getItem('accessToken')
    if (accessToken) {
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`
      }
    }

    if (tryAuthRefresh && !Auth.isTokenValid() && !url.toString().includes('auth')) {
      await Auth.refreshToken()
    }

    let res
    try {
      res = await fetch(url, options)
    } catch (ex) {
    }

    // if not successful, try refreshing auth token and try again
    if (!res || res.status >= 400) {
      if (tryAuthRefresh && await Auth.refreshToken()) {
        const res = await fetch(url, options)
      }
    }

    return res || new Response()
  }
}
